import { CloseButton, Tooltip, UnstyledButton } from "@mantine/core";
import { AudioLines } from "lucide-react";

import type { Voice } from "../../api/generated/model";
import classes from "./voices.module.css";

/** Live's tooltip on the empty tile (`text-to-speech/constants.ts`). */
const TIP =
  "Choose the voice for your narration. Use an existing voice, upload one, record your own, or generate a new AI voice.";

export interface VoiceTileProps {
  /** The voice the form holds, or none. */
  voice: Voice | null;
  /** Live's tooltip on the empty tile, where the form has its own (Promote Your Product's). */
  tip?: string;
  /** Opens live's Voice Settings. */
  onOpen: () => void;
  onRemove: () => void;
}

/**
 * Live's voice slot in a composer (`voice-field`, captures 02 and 03): "Voice Settings" on the
 * slot's gradient with live's tooltip; once a voice is chosen, its name on the accent with an x
 * that removes it. Either opens the panel.
 */
export function VoiceTile({ voice, tip = TIP, onOpen, onRemove }: VoiceTileProps) {
  if (voice === null) {
    return (
      <Tooltip label={tip} multiline maw={460} withArrow>
        <UnstyledButton className={classes.tile} aria-label="Voice Settings" onClick={onOpen}>
          <AudioLines size={20} strokeWidth={1.5} aria-hidden />
          <span>Voice Settings</span>
        </UnstyledButton>
      </Tooltip>
    );
  }
  return (
    <span className={classes.tileWrap}>
      <UnstyledButton
        className={classes.tile}
        data-chosen
        aria-label={`Voice Settings: ${voice.name}`}
        onClick={onOpen}
      >
        <AudioLines size={20} strokeWidth={1.5} aria-hidden />
        <span className={classes.tileName}>{voice.name}</span>
      </UnstyledButton>
      <CloseButton
        size="sm"
        className={classes.tileRemove}
        aria-label="Remove the voice"
        onClick={onRemove}
      />
    </span>
  );
}
